// The connected-sources API answers "no results" as [[]]; treat that the same
// as an empty list.
export const isArrayControl = (arr) => {
    if (
        Array.isArray(arr) &&
        arr.length === 1 &&
        Array.isArray(arr[0]) &&
        arr[0].length === 0
    ) {
        return false;
    }
    return Array.isArray(arr) && arr.length > 0;
};
